
import React from 'react';
import { TutorialProvider } from '@/context/tutorial/TutorialContext';

interface TutorialControllerProps {
  children: React.ReactNode;
}

/**
 * Componente wrapper per fornire il contesto del tutorial a tutta l'applicazione
 */
const TutorialController: React.FC<TutorialControllerProps> = ({ children }) => {
  return (
    <TutorialProvider>
      {children}
    </TutorialProvider>
  );
};

export default TutorialController;
